import { ApiHandler, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { getRetailModeSettings, GetRetailModeSettingsApiParameter } from "@store/Services/RetailModeService";
import setRetailModeStatus from "@store/Store/Data/RetailMode/Handlers/SetRetailModeStatus";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { RetailModeSettingsModel } from "@store/Types/RetailModeSettings";

type Parameter = GetRetailModeSettingsApiParameter;
type Props = StoreHandlerProps & {
    settings?: RetailModeSettingsModel;
    result: RetailModeSettingsModel;
};

type HandlerType = ApiHandler<Parameter, RetailModeSettingsModel, Props>;

export const DispatchBeginLoadSettings: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/RetailModeSettings/BeginLoadSettings",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    if (!props.parameter.force) {
        props.settings = props.getState().store.data.retailModeSettings.retailModeSettings;

        if (props.settings) {
            return;
        }
    }

    await getRetailModeSettings(props.apiParameter).then((response) => {
        props.apiResult = response;
    }, (error) => {});
};

export const SetResultForSettings: HandlerType = props => {
    props.result = props.settings || props.apiResult;
};

export const DispatchCompleteLoadRetailModeSettings: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/RetailModeSettings/CompleteLoadSettings",
        settings: props.result,
    });
};

export const SetRetailModeStatus: HandlerType = props => {
    if (props.apiResult !== undefined) {
        props.dispatch(setRetailModeStatus(props.result));
    }
};

export const chain = [
    DispatchBeginLoadSettings,
    RequestDataFromApi,
    SetResultForSettings,
    DispatchCompleteLoadRetailModeSettings,
    SetRetailModeStatus,
];

const loadRetailModeSettings = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadRetailModeSettings");
export default loadRetailModeSettings;
